import { DirectReportMonthlyData } from "@/entities/reporting/types";
import { UserData } from "@/entities/users/types";

export enum LeadAnalysisKPI {
  avgMonthlyQualifiedConvertedLeads = "avgMonthlyQualifiedConvertedLeads",
  LeadQualificationRate = "leadQualificationRate",
  LeadConversionRate = "leadConversionRate"
}

export const TAB_CONFIG = {
  avgNewLeads: {
    kpi: LeadAnalysisKPI.avgMonthlyQualifiedConvertedLeads,
    translationKey: "leadAnalysis.kpi.avgNewLeads"
  },
  leadQualification: {
    kpi: LeadAnalysisKPI.LeadQualificationRate,
    translationKey: "leadAnalysis.kpi.leadQualification"
  },
  leadConversion: {
    kpi: LeadAnalysisKPI.LeadConversionRate,
    translationKey: "leadAnalysis.kpi.leadConversion"
  }
};

export type TabId = keyof typeof TAB_CONFIG;

export const TAB_IDS = Object.keys(TAB_CONFIG) as TabId[];

export interface PeerComparisonResult {
  you: { value: number | null };
  team: { value: number | null };
  org: { value: number | null };
  industry: { value: number | null };
}

export type UserLine = {
  userId: string;
  lineColor: string;
  dotColor: string;
};

export type ChartDataPoint = {
  month: string;
  originalMonth: string;
  [userId: string]: string | number;
};

export type MonthlyLeadsChartProps = {
  data: DirectReportMonthlyData;
  userMap: Map<string, UserData>;
  height?: number;
  isPercentage?: boolean;
};
